import { Col, Modal, Row } from 'antd'
import { Link } from 'gatsby'

type ModalProps = {
  url?: string
  isModalOpen: boolean
  setIsModalOpen?: (flag: boolean) => void
}

export const ModalCommon = ({ isModalOpen, setIsModalOpen, url }: ModalProps) => {
  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  return (
    <>
      <Modal
        centered
        // title={categoryText}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Row>
          <Col span={24} className="text-center">
            {/* <Link to={url}>{url}</Link> */}
            <a href={url} target="_blank" rel="noreferrer">
              PDFを開く
            </a>
          </Col>
        </Row>
      </Modal>
    </>
  )
}
